<template>
  <div class="mb-2 fileContent">
    <a-spin class="contentItem" v-if="show" />
    <img class="contentItem" v-if="!show && url" :src="url" style="width: 400px;" />
    <a-result class="contentItem" status="500" :title="$t('scope.text_908')" v-if="!show && !url" :subTitle="$t('scope.text_909')" />
  </div>
</template>

<script>
import { uuid } from '@/utils/utils'

function transfromFile (type, imageFile) {
  const transfromImage = Buffer.from(imageFile, 'binary').toString('base64')
  return `data:${type};base64,${transfromImage}`
}

export default {
  name: 'paperworkFile',
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      url: '',
      show: true,
    }
  },
  async mounted () {
    try {
      const data = await this.fetchFiles(this.type)
      this.url = transfromFile(data.headers['content-type'], data.data)
      this.show = false
    } catch (error) {
      this.show = false
    }
  },
  methods: {
    fetchFiles (type) {
      return this.$http({
        url: '/v2/enterprise-attachments',
        method: 'get',
        processData: false,
        headers: {
          'X-Enterprise-Meta-Type': type,
          'X-Enterprise-Meta-CustomerID': this.id,
          'Content-Type': 'application/octet-stream',
        },
        responseType: 'arraybuffer',
        params: {
          $t: uuid(),
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.fileContent {
  display: flex;
  justify-content: center;
  align-items:center;
  .contentItem {
    display: block;
    margin: 0 auto;
  }
}
</style>
